/**
 * @file SalesEquipmentPage.jsx
 * @description SALES department — Equipments.
 *
 * The rentable fleet from the sales side.
 *
 * This file belongs to the SALES department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for SALES is made HERE and can never leak into another
 * department's screens. The shared engine underneath (RentalPage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only SALES users (and the
 * super admin) can open it.
 */
import React from 'react';
import RentalPage from '../RentalPage';

const SalesEquipmentPage = () => (<RentalPage forcedView="fleet" />);

export default SalesEquipmentPage;
